export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
// https://forkify-api.herokuapp.com/api/v2/recipes/

export const TIMEOUT_SEC = 10;

export const RES_PER_PAGE = 10;

export const KEY = '32ae74f5-ac31-4af9-ab19-f69bfe2534bc';

export const MODAL_CLOSE_SECONDS = 2.5;
